import React from 'react';
import DiscordIcon from './discord.svg';
const BrandColor = '#5865F2';
export const Discord = () => React.createElement(DiscordIcon, { fill: BrandColor });
